/**
 * Точка возврата к выгрузке из списка фоновых задач.
 *
 * Виджет фоновых задач отдаёт клик по задаче наверх; шапка приложения
 * подставляет этот слот. Если задача — выгрузка карточек, открывается то же
 * окно статуса с тем же содержимым; иначе слот молчит и показывается обычное
 * окно прогресса.
 */

import { isPublishCardsJob } from './publishJobsStore'
import { PublishStatusModal } from './PublishStatusModal'

interface PublishJobModalSlotProps {
  job: { jobId?: string; type?: string } | null
  isOpen: boolean
  onClose: () => void
}

export function PublishJobModalSlot({ job, isOpen, onClose }: PublishJobModalSlotProps) {
  if (!job?.jobId || !isPublishCardsJob(job)) return null
  return <PublishStatusModal jobId={job.jobId} isOpen={isOpen} onClose={onClose} />
}

export default PublishJobModalSlot
